import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSidebarData } from '../../../hooks/sidebarData';
import { useQuery } from '@tanstack/react-query';
import axios from '../../../api/axios';
import { destroySession } from '../../../helpers/Session';

const LeaveDetails = () => {
    const navigate = useNavigate();
    const { sidebarData } = useSidebarData();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');

    const { data: leave, isLoading, error } = useQuery({
        queryKey: ['userLeaveRequestDetails', { sidebarData }],
        queryFn: async () => {
            const res = await axios.get(`leaves/details/${sidebarData.data?.uname}?id=${sidebarData.data?.leaverequestid}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!sidebarData.data?.uname && !!sidebarData.data?.leaverequestid && !!accesstoken,
        retry: 1
    });
    

    useEffect(() => {
        if (error) {
            if (error.response.data?.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [error]);

    return (
      <div className={`leave-request ${isLoading ? "loading" : ""}`}>
        <table>
          <tbody>
            <tr>
              <th>Name</th>
              <td>
                <span>{leave?.name}</span>
              </td>
            </tr>
            <tr>
              <th>Leave</th>
              <td>
                <span>{leave?.leave}</span>
              </td>
            </tr>
            <tr>
              <th>Leave Type</th>
              <td>
                <span>
                  {leave?.leavetype === 1 ? "With Pay" : "Without Pay"}
                </span>
              </td>
            </tr>
            <tr>
              <th>Start Date</th>
              <td>
                <span>{leave?.startdate}</span>
              </td>
            </tr>
            <tr>
              <th>End Date</th>
              <td>
                <span>{leave?.enddate}</span>
              </td>
            </tr>
            <tr>
              <th>Duration</th>
              <td>
                <span>{leave?.duration}</span>
              </td>
            </tr>
            <tr>
              <th colSpan={2}>Reason</th>
            </tr>
            <tr>
              <td colSpan={2}>
                <span>{leave?.leave}</span>
              </td>
            </tr>
            {leave?.attachment.length > 0 && (
              <>
                <tr>
                  <th colSpan={2}>Attachments</th>
                </tr>
                <tr>
                  <td colSpan={2}>
                    {leave?.attachment.map((item) => (
                      <span>
                        <a
                          href={item.url}
                          target="_blank"
                          title={item.name}
                          className="icon"
                        >
                          <i
                            className={`fa ${
                              item.type === "pdf"
                                ? "fa-file-pdf"
                                : item.type === "doc" || item.type === "docx"
                                ? "fa-file-word"
                                : "fa-file-image"
                            }`}
                          ></i>
                        </a>
                      </span>
                    ))}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>

        {leave?.approvals?.length > 0 && (
          <div className="approvals-section">
            <table className="approval-table">
              <thead>
                <tr>
                  <th colSpan="3" className="header-title">
                    APPROVALS
                  </th>
                </tr>
                <tr>
                  <th className="header-cell">Name</th>
                  <th className="header-cell">Status</th>
                  <th className="header-cell">Date</th>
                </tr>
              </thead>
              <tbody>
                {leave.approvals.map((approval, index) => {
                  const statusNum = Number(approval.status);
                  const statusClass =
                    statusNum === 1
                      ? "approved"
                      : statusNum === 2
                      ? "disapproved"
                      : "pending";
                  const statusLabel =
                    statusNum === 1
                      ? "Approved"
                      : statusNum === 2
                      ? "Disapproved"
                      : "Pending";

                  return (
                    <tr key={index}>
                      <td>{approval.name}</td>
                      <td style={{ textAlign: "center" }}>
                        <span className={`status-badge ${statusClass}`}>
                          {statusLabel}
                        </span>
                      </td>
                      <td>
                        {leave?.status === 3 && approval.status === 0
                          ? ""
                          : approval.date
                          ? (() => {
                              const date = new Date(approval.date);
                              const formattedDate = date.toLocaleDateString(
                                "en-US",
                                {
                                  month: "long",
                                  day: "numeric",
                                  year: "numeric",
                                }
                              );
                              const formattedTime = date.toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              );
                              return (
                                <>
                                  {formattedDate}
                                  <br />
                                  {formattedTime}
                                </>
                              );
                            })()
                          : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
}

export default LeaveDetails